import { DataTable, Text } from 'bold-ui'
import { SdcFatorVerificadoDto } from 'graphql/types.generated'

interface SdcFatorRiscoTableProps {
  rows: ReadonlyArray<SdcFatorVerificadoDto>
}

export const SdcFatorRiscoTable = (props: SdcFatorRiscoTableProps) => {
  const { rows } = props

  return (
    <DataTable<SdcFatorVerificadoDto>
      data-cy='SdcFatorRiscoTable'
      rows={rows}
      columns={[
        { name: 'fatorRisco', header: 'Fator de risco', render: (item) => <Text>{item?.fatorRisco}</Text> },
        {
          name: 'ondeSistemaVerifica',
          header: 'Onde o sistema verifica a informação',
          render: (item) => <Text dangerouslySetInnerHTML={{ __html: item?.ondeSistemaVerifica }} />,
          style: { minWidth: '16rem' },
        },
      ]}
    />
  )
}
